import * as React from 'react';

import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      onWheel={
        type === 'number'
          ? (e) => {
              // Prevent scroll from changing the value
              e.currentTarget.blur();
            }
          : undefined
      }
      className={cn(
        'flex h-9 w-full min-w-0 bg-surface-3 px-3 py-2.5 cs-input-value shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:cs-input-value autofill:!bg-surface-3 autofill:!text-text-strong disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm bg-surface-3',
        // 'focus-visible:border-ring focus-visible:ring-[1px] focus-visible:ring-ring/50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',

        type === 'number' &&
          '[&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none',
        className,
      )}
      style={
        type === 'number'
          ? {
              MozAppearance: 'textfield',
            }
          : undefined
      }
      {...props}
    />
  );
}

export { Input };
